import { Flex } from '@chakra-ui/core'
import { css } from '@emotion/core'
import { Images, Paperclip } from 'lucide-react'
import React from 'react'

interface IProps {
  onFileUploadClick: () => void
  onImageUploadClick: () => void
}
export const AddMediaButtonts: React.FC<IProps> = ({ onFileUploadClick, onImageUploadClick }) => {
  return (
    <Flex
      alignItems="flex-start"
      style={{ columnGap: '10px' }}
      css={css`
        & > * {
          transition: transform 0.3s ease, margin 0.3s ease;
        }

        & > *:hover {
          transform: scale(1.2);
        }
      `}
    >
      <Flex
        onClick={onFileUploadClick}
        borderRadius="full"
        bg="black"
        w="30px"
        h="30px"
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        boxShadow="0px 0px 2px 1px white"
      >
        <Paperclip color="white" size={15} />
      </Flex>
      <Flex
        onClick={onImageUploadClick}
        borderRadius="full"
        bg="black"
        w="30px"
        h="30px"
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        boxShadow="0px 0px 2px 1px white"
      >
        <Images color="white" size={15} />
      </Flex>
    </Flex>
  )
}
